// Function loadParallaxFullWidthBlock loads the ParallaxFullWidthBlock class by dynamically importing the js on demand if needed

export function loadParallaxFullWidthBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-parallax-full-width-block-chunk" */ '../widgets/parallaxFullWidthBlock').then(wg => {

		const { ParallaxFullWidthBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ParallaxFullWidthBlock"]');

		if(!$wg) {
			// console.info('ParallaxFullWidthBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ParallaxFullWidthBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ParallaxFullWidthBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ParallaxFullWidthBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ParallaxFullWidthBlock widget');

}
